import { Entries } from 'type-fest'
import { isNotEmptyStringUndefinedOrNull } from '@App/helpers/is-not-empty-string'

export const stripEmptyFilters = <K extends object>(filters: K | undefined): K | undefined => {
    if (!filters) {
        return filters
    }
    const entries = Object.entries(filters) as Entries<K>

    return Object.fromEntries(entries.filter(([, value]) => isNotEmptyStringUndefinedOrNull(value))) as K
}
